/**
 * Interface that provides metadata for the internal updates of the HoneyGrid system
 * like updated dates
 */
import { z } from 'zod/v4'

export const HoneygridMetadataValidator = z.object({
        id: z.string(),
        honeygridUpdatedAt: z.string(),
})

export type HoneygridMetadata = z.infer<typeof HoneygridMetadataValidator>
